/** Элементы, которые письмо не вправе приносить в интерфейс. */
const FORBIDDEN_ELEMENTS =
  "script, iframe, object, embed, link, base, form, input, button, meta, style";

/**
 * Атрибуты, через которые элемент сам идёт во внешний ресурс. `background`,
 * `poster` и `xlink:href` браузер загружает без скриптов, поэтому их убирают
 * так же, как `src` и `href`: письмо не должно сообщать отправителю, что его
 * открыли (трекинговый пиксель).
 */
const RESOURCE_ATTRIBUTES = new Set([
  "src",
  "href",
  "xlink:href",
  "background",
  "poster",
  "data",
  "action",
  "formaction",
  "ping",
]);

/**
 * Последний рубеж очистки HTML письма перед показом в изолированном iframe.
 *
 * Сервер уже отдаёт очищенный HTML, но клиент не полагается на него одного:
 * убирает исполняемые и стилевые элементы, обработчики событий, встроенные
 * стили и любые ссылки на внешние ресурсы. Разрешены только `cid:`-ссылки на
 * вложения самого письма. Результат отдаётся в `srcDoc` iframe с пустым
 * `sandbox`, то есть без скриптов и переходов.
 */
export function safeMailHtml(source: string): string {
  const document = new DOMParser().parseFromString(source, "text/html");
  document
    .querySelectorAll(FORBIDDEN_ELEMENTS)
    .forEach((element) => element.remove());
  document.querySelectorAll("*").forEach((element) => {
    for (const attribute of [...element.attributes]) {
      const name = attribute.name.toLowerCase();
      if (name.startsWith("on") || name === "style" || name === "srcset") {
        element.removeAttribute(attribute.name);
      } else if (
        RESOURCE_ATTRIBUTES.has(name) &&
        !attribute.value.trim().toLowerCase().startsWith("cid:")
      ) {
        element.removeAttribute(attribute.name);
      }
    }
  });

  return document.body.innerHTML;
}
